import useDocumentRepositoryTable from "./useDocumentRepositoryTable"
import Table from "./Table"


const DocumentRepositoryTable = ({
  items,
  selectedAttachmentIds,
  hasVisibleAttachments,
  isAllVisibleSelected,
  toggleAttachmentSelection,
  toggleAllVisibleSelection,
}) => {
  const { columns, loaded } = useDocumentRepositoryTable({
    selectedAttachmentIds,
    hasVisibleAttachments,
    isAllVisibleSelected,
    toggleAttachmentSelection,
    toggleAllVisibleSelection,
  });

  return (
    <Table
      columns={columns}
      loaded={loaded}
      data={items}
    />
  )
}

export default DocumentRepositoryTable;
